



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';
import i18next from 'i18next';

@Component({
  components: { Translation, FormField },
})
export default class TextFieldDirect extends Vue {
  @Prop([String, Number])
  public value!: string | number;

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public placeholder!: string;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(String)
  public label!: string;

  @Prop({ type: String, default: 'text' })
  public type!: string;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Prop(Object)
  public validationError!: ValidationError | null;

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  @Emit()
  public infoClick(): void {}
}
